import * as React from 'react';
import Container from '@mui/material/Container';

export default function VenueMap() {
  return (
    <Container sx={{
      height: "auto",
      aspectRatio: "16 / 9",
      maxHeight: "450px",
    }}>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d810.3463693323824!2d-71.07075173877722!3d42.36678511926783!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e3714c5f63f189%3A0xf245441112dd973!2sWashburn%20Pavilion!5e1!3m2!1sen!2sus!4v1734826999423!5m2!1sen!2sus" 
        width="100%" 
        height="100%"
        allowfullScreen="" 
        loading="lazy" 
        referrerpolicy="no-referrer-when-downgrade" />
    </Container>
  );
}
